import { useLocation } from 'react-router-dom';
import { markSignInContinuation } from '../lib/continuation';

/**
 * The only screen an unauthenticated visitor sees. There is no preview of
 * research content and no demo login: access starts with Discord OAuth and an
 * invitation for that Discord account.
 */
export function SignIn({ notInvited = false }: { notInvited?: boolean }) {
  const { pathname } = useLocation();
  return (
    <main className="signin" id="main" tabIndex={-1}>
      <div className="signin__panel">
        <img src="/brand/logo-long.png" alt="GitFitCode" width={801} height={295} className="signin__logo" />
        <p className="eyebrow">Research hub · invited members</p>
        <h1 className="signin__title">{notInvited ? 'This Discord account is not invited yet' : 'Sign in to read the research'}</h1>
        {notInvited ? (
          <p className="signin__lede">
            You signed in, but this hub only opens for Discord accounts a steward has invited. Ask a GitFitCode steward to
            invite your Discord account, then sign in again. Nothing about you was recorded beyond the failed attempt.
          </p>
        ) : (
          <p className="signin__lede">
            A living account of how GitFitCode members have learned, helped and built together — with the evidence,
            the disagreements and the gaps left in. It is private to invited members, so we ask you to sign in with the
            Discord account you use in the community.
          </p>
        )}
        <a className="button button--primary button--large" href="/auth/discord" onClick={() => markSignInContinuation(pathname)}>
          {notInvited ? 'Try a different Discord account' : 'Continue with Discord'}
        </a>
        <p className="signin__fine">
          We only ask Discord for your account ID and display name. You choose separately how you are credited in the
          research.
        </p>
      </div>
    </main>
  );
}
